import React, { useState } from 'react';

// Helper Functions
const formatDate = (dateString, withTime = false) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const options = { day: "numeric", month: "short", year: "numeric" };
  let formatted = date.toLocaleDateString("en-GB", options);
  if (withTime) {
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
    const timeStr = date.toLocaleTimeString("en-GB", timeOptions);
    formatted += ", " + timeStr;
  }
  return formatted;
};

const formatCurrency = (num) => {
  return num == null || isNaN(num) ? '₹ 0' : '₹ ' + Number(num).toLocaleString('en-IN');
};

const getPaymentModeName = (item) => {
  if (item?.vendor_type === 5) return item?.vendor_detail?.name || "-";
  const mode = item?.payment_mode?.name || "";
  let acc = "";
  if (item?.payment_mode?.account_sub_category === 2) {
    const bank = item?.payment_mode?.account?.name || "";
    const num = item?.vendor_bank_account?.account_number || "";
    acc = bank && num ? `${bank} ${num.replace(/.(?=.{4})/g, "X")}` : (bank || num || "-");
  } else {
    acc = item?.payment_mode?.account?.name || "-";
  }
  return mode ? `${mode} ${acc}` : acc;
};

const getCategoryName = (item) => {
  if (!item?.categories || !Array.isArray(item.categories)) return 'Uncategorized';
  const names = item.categories
    .map(cat => cat?.category?.name)
    .filter(name => name && name.trim() !== '');
  return names.length ? names.join(', ') : 'Uncategorized';
};

const TransportTripDetails = ({
  trip_detail = {},
  balance_freight = [],
  advance_freight = [],
  claim_pay = [],
  claim_charge = [],
  freight_summary = {},
  logo = "https://via.placeholder.com/28",
  redirect_url = "#"
}) => {
  const [activeAccordion, setActiveAccordion] = useState(['collapseOne']);
  const [sliderPosition, setSliderPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  const toggleAccordion = (id) => {
    setActiveAccordion(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleStart = (e) => {
    if (isCompleted) return;
    setIsDragging(true);
  };

  const handleMove = (e) => {
    if (!isDragging || isCompleted) return;

    const container = e.currentTarget;
    const containerWidth = container.offsetWidth;
    const sliderWidth = 60;
    const maxSlide = containerWidth - sliderWidth;

    let clientX;
    if (e.type.includes('touch')) {
      clientX = e.touches[0].clientX;
    } else {
      clientX = e.clientX;
    }

    const rect = container.getBoundingClientRect();
    let newPosition = clientX - rect.left - (sliderWidth / 2);

    if (newPosition < 0) newPosition = 0;
    if (newPosition > maxSlide) newPosition = maxSlide;

    setSliderPosition(newPosition);

    if (newPosition >= maxSlide * 0.95) {
      setIsCompleted(true);
      setIsDragging(false);
      window.location.href = "https://play.google.com/store/apps/details?id=com.transport360app&hl=en_IN";
    }
  };

  const handleEnd = () => {
    setIsDragging(false);
    if (!isCompleted) {
      setSliderPosition(0);
    }
  };

  const summary = typeof freight_summary === "object" && freight_summary !== null ? freight_summary : {};

  const statusMap = {
    1: "Draft",
    2: "In Transit",
    3: "At Party",
    4: "Delivered",
    5: "Cancelled"
  };
  const currentStatus = statusMap[trip_detail?.trip_status] || "Unknown";

  const fromLoc = Array.isArray(trip_detail?.from_location) && trip_detail.from_location.length > 0
    ? trip_detail.from_location[0] : null;
  const toLoc = Array.isArray(trip_detail?.to_location) && trip_detail.to_location.length > 0
    ? trip_detail.to_location[trip_detail.to_location.length - 1] : null;
  const fromCities = [fromLoc?.from_city, fromLoc?.from_state].filter(Boolean).join(" | ") || "Origin Not Specified";
  const toCities = [toLoc?.to_city, toLoc?.to_state].filter(Boolean).join(" | ") || "Destination Not Specified";

  const balFreightList = Array.isArray(balance_freight) ? balance_freight : [];
  const advFreightList = Array.isArray(advance_freight) ? advance_freight : [];
  const payableClaims = Array.isArray(claim_pay) ? claim_pay : [];
  const deductionClaims = Array.isArray(claim_charge) ? claim_charge : [];

  return (
    <>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background-color: #f1f1f3; font-family: "Roboto", sans-serif; }
        
        .__mainMob {
          background-color: #F5F8FD; max-width: 480px; width: 100%; height: 100vh;
          margin: 0 auto; display: flex; overflow: auto; flex-direction: column;
          scrollbar-width: none; -ms-overflow-style: none;
        }
        .__mainMob::-webkit-scrollbar { display: none; }

        .__headMob {
          display: flex; background-color: #ffffff; min-height: 63px;
          align-items: center; padding: 0 12px; gap: 9px; border: 1px solid #E8E7E7;
        }
        .__headMob h1 {
          font-family: "Inter", sans-serif; font-size: 19.45px;
          color: #000D25; font-weight: 500; margin: 0;
        }
        .__headMob h1 span { color: #0066FF; }
        .__hedIcon {
          width: 37px; height: 37px; border: 1px solid #dededee6;
          border-radius: 7px; display: flex; justify-content: center; align-items: center;
        }
        .__hedIcon img { width: 28px; }
        .__bodyMob { flex: 1; display: flex; flex-direction: column; gap: 6px; }
        
        .__whtHed {
          background-color: #ffffff; padding: 19px 16px 16px; border: 1px solid #E8E7E7;
        }
        .__whtHed h4 {
          font-size: 16px; color: #101828; line-height: 24px; margin-bottom: 4px;
        }
        .__whtHed p { font-size: 12px; color: #4A5565; margin-bottom: 4px; }
        .__whtHed p:last-child { margin-bottom: 0px; }
        
        .__plpHd_txt {
          background-color: #F0F1FB; border: 1px solid #E8E7E7; padding: 8px 12px;
        }
        .__plpHd_txt h3, .__plpDetails h3 {
          font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 0px;
        }
        .__plpHd_txt h3 { color: #000000; }
        
        .__plpDetails {
          background-color: #ffffff; border-bottom: 1px solid #E8E7E7;
          padding: 12px 12px 14px; display: flex; justify-content: space-between;
          align-items: center; flex-wrap: wrap;
        }
        .__plpDetails h3 { color: #101828; }
        .__plpDetails p { font-size: 12px; color: #6A7282; margin: 0px; }
        
        .__inTr_tag {
          min-height: 27px; min-width: 71px; font-size: 12px;
          background-color: #DCFCE7; color: #008236; display: flex;
          align-items: center; justify-content: center; border-radius: 50px;
        }
        
        .__vhlDetailBx {
          background-color: #ffffff; border: 1px solid #E8E7E7; padding: 16px 18px 20px;
        }
        .__vhlDetailBx h3 {
          font-size: 16px; color: #003C97; margin-bottom: 0px; line-height: 27px;
        }
        .__vhlDetailBx p { font-size: 12px; color: #6A7282; margin: 0px; }
        
        .route {
          font-size: 15px; display: flex; flex-direction: column;
          gap: 20px; overflow: hidden; position: relative; margin-top: 20px;
        }
        .route-row { display: flex; align-items: baseline; gap: 12px; margin-bottom: 0px; }
        
        span.source-icon:after {
          content: ""; position: absolute; width: 0px; height: calc(100% - 4px);
          border-right: 1px dashed #c4c4c4; z-index: 0; top: 3px;
        }
        .source-icon, .destination-icon {
          display: inline-flex; width: 20px; justify-content: center; align-items: center;
        }
        .source-icon i { color: #4caf50; z-index: 1; background: #fff; }
        .destination-icon i { color: #f44336; }
        span.destination-icon, .source-icon i { position: relative; }
        .route-text { flex: 1; line-height: 19px; }
        .route-row .city { font-weight: 600; color: #333; font-size: 16px; }
        
        .__lrSep_bxs {
          background-color: #ffffff; border: 1px solid #e8e7e7;
          padding: 12px 12px 8px; border-radius: 4px;
        }
        
        .__pdAccordian { display: flex; flex-direction: column; gap: 13px; }
        .__smAccr { display: flex; justify-content: space-between; }
        .__smAccr h2 {
          font-size: 16px; color: #000000; font-weight: 400; margin: 0px;
        }
        
        .__pdAccordian .accordion {
          display: flex; flex-direction: column; gap: 12px;
        }
        .__pdAccordian .accordion-item { border: none; }
        .__pdAccordian .accordion-button {
          padding: 0px; background: transparent; border: none;
          width: 100%; display: flex; align-items: center;
          cursor: pointer; box-shadow: none;
        }
        .__pdAccordian .accordion-button:focus { box-shadow: none; }
        .__pdAccordian .accordion-button .__firstSpan { order: 1; }
        
        .__pdAccordian .accordion-button:not(.no-arrow)::after {
          order: 2; margin-left: 7px; content: "";
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
          width: 15px; height: 15px; background-size: 15px;
          background-repeat: no-repeat; transition: transform 0.2s;
        }
        .__pdAccordian .accordion-button:not(.no-arrow).collapsed::after {
          transform: rotate(-90deg);
        }
        
        .__pdAccordian .accordion-button.no-arrow::after {
          display: none !important; content: none !important;
          width: 0 !important; height: 0 !important;
          margin: 0 !important; background: none !important;
        }
        .__pdAccordian .accordion-button.no-arrow {
          cursor: default !important; pointer-events: none !important;
        }
        
        .__pdAccordian .accordion-button .__thirdSpan {
          order: 3; margin-left: auto;
        }
        .__pdAccordian .accordion-button .__firstSpan,
        .__pdAccordian .accordion-button .__thirdSpan {
          font-size: 15px; color: #000000; font-weight: 400;
        }
        
        .__pdAccordian .accordion-body {
          border: 1px solid #DBE5FF; border-radius: 8px;
          margin-top: 6px; padding: 0px 11px; display: none;
        }
        .__pdAccordian .accordion-body.show { display: block; }
        
        .__innerTb_xs { padding: 10px 0px 10px; border-bottom: 1px solid #DBE5FF; }
        .__innerTb_xs:last-child { border-bottom: 0px; }
        
        .__belowRtc p {
          font-size: 12px; color: #000000; margin: 0px; opacity: 0.5;
        }
        
        .__underAppro_tag {
          font-size: 8px; border: 1px solid #F7D838;
          background-color: #FFF9E2; color: #494634cc;
          min-height: 16px; min-width: 64px; display: inline-flex;
          justify-content: center; align-items: center;
          margin-left: 3px; border-radius: 3px;
        }
        .__innerTb_xs .__smAccr h2 { display: flex; align-items: center; }
        
        .__footmob { padding-top: 18px; }
        .__footFirst { padding-bottom: 127px; }
        .__footFirst p {
          font-size: 12px; color: #4A5565; margin: 0px; text-align: center;
        }
        .__footFirst p span { color: #000000; }
        
        .__footSecond {
          background-color: #ffffff; padding: 8px 18px 12px;
          position: fixed; width: 100%; bottom: 0px; left: 0;
        }
        .__footSecond p {
          color: #4A5565; margin-bottom: 8px; text-align: center; font-size: 14px;
        }
        
        .__slideButton {
          position: relative; background: linear-gradient(90deg, #1956F6 0%, #0d3db8 100%);
          border-radius: 8px; min-height: 52px; width: 100%;
          overflow: hidden; cursor: pointer; user-select: none;
          touch-action: none;
        }
        
        .__slideButton.__completed {
          background: linear-gradient(90deg, #00C853 0%, #00962f 100%);
        }
        
        .__slideTrack {
          position: absolute; top: 0; left: 0; right: 0; bottom: 0;
          display: flex; align-items: center; justify-content: center;
          pointer-events: none;
        }
        
        .__slideText {
          font-size: 16px; color: #ffffff; font-weight: 500;
          transition: opacity 0.3s; z-index: 1;
        }
        
        .__slideButton.__dragging .__slideText {
          opacity: 0.5;
        }
        
        .__slideButton.__completed .__slideText {
          opacity: 1;
        }
        
        .__slider {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 56px;
    background: rgb(255 255 255 / 18%);
    backdrop-filter: blur(-1px);
    border: 1px solid rgb(255 255 255 / 0%);
    border-radius: 6px;
    display: flex
;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: left 0.1s ease-out;
    z-index: 2;
}
        
        .__slider i {
          font-size: 20px; color: #ffffff;
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          transition: transform 0.3s;
        }
        
        .__slideButton.__dragging .__slider {
          transition: none;
        }
        
        .__slideButton.__completed .__slider {
          left: calc(100% - 60px) !important;
          background: rgba(0, 200, 83, 0.4);
          border: 1px solid rgba(255, 255, 255, 0.5);
        }
        
        .__slideButton.__completed .__slider i {
          color: #ffffff; transform: scale(1.2);
        }
      `}</style>

      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Roboto:wght@400;500&display=swap"
        rel="stylesheet"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
      />

      <section className="__mainMob">
        <div className="__headMob">
          <div className="__hedIcon">
            <img src={logo} alt="logo" />
          </div>
          <h1>Transport <span>360</span></h1>
        </div>

        <div className="__bodyMob">
          <div className="__whtHed">
            <h4>{trip_detail?.company_id?.company || 'Company Name'}</h4>
            <p>{[trip_detail?.company_id?.address_line1, trip_detail?.company_id?.city?.label].filter(Boolean).join(", ") || 'Address'}</p>
            <p>
              Contact: <a href={`tel:${trip_detail?.company_id?.contact_no}`}>{trip_detail?.company_id?.contact_no || 'N/A'}</a>
              &nbsp;&nbsp;&nbsp; PAN: {trip_detail?.company_id?.pan_no || 'N/A'}
            </p>
            <p>GSTIN: {trip_detail?.company_id?.gst_no || 'N/A'}</p>
          </div>

          <div className="__plp_head">
            <div className="__plpHd_txt">
              <h3>Supplier Trip & Payment Details</h3>
            </div>

            <div className="__plpDetails">
              <div>
                <h3>Trip #{trip_detail?.trip_number || "Not Available"}</h3>
                <p>{formatDate(trip_detail?.dispatch_date, true) || "Date & Time Not Set"}</p>
              </div>

              <div className="__inTr_tag">{currentStatus}</div>

              <div style={{ flex: '100%', marginTop: '14px' }}>
                <div className="__smAccr">
                  <h2 style={{ color: '#101828' }}>{trip_detail?.supplier_id?.name || "Not Available"}</h2>
                  <h2 style={{ color: '#101828' }}>{trip_detail?.supplier_id?.pan_no || "Not Available"}</h2>
                </div>

                <div className="__smAccr" style={{ marginTop: '5px' }}>
                  <p>Supplier Details</p>
                  <p>PAN Number</p>
                </div>
              </div>
            </div>
          </div>

          <div className="__vhlDetailBx">
            <h3>{trip_detail?.vehicle_id?.vehicle_no || "No vehicle assigned"}</h3>
            <p>Vehicle Number</p>

            <div className="route">
              <div className="route-row">
                <span className="source-icon"><i className="fa-regular fa-circle"></i></span>
                <div className="route-text"><span className="city">{fromCities}</span></div>
              </div>
              <div className="route-row">
                <span className="destination-icon"><i className="fa-solid fa-location-dot"></i></span>
                <div className="route-text"><span className="city">{toCities}</span></div>
              </div>
            </div>
          </div>

          <div className="__lrSep_bxs" style={{ paddingLeft: '18px', paddingRight: '18px', borderRadius: 0, border: 0 }}>
            <div className="__pdAccordian">
              <div className="__smAccr">
                <h2>Total Freight</h2>
                <h2>{formatCurrency(summary.total_freight)}</h2>
              </div>

              <div className="accordion">
                {/* Freight Payment */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${activeAccordion.includes('collapseOne') ? '' : 'collapsed'
                        } ${balFreightList.length === 0 ? 'no-arrow' : ''}`}
                      type="button"
                      onClick={() => balFreightList.length > 0 && toggleAccordion('collapseOne')}
                    >
                      <span className="__firstSpan">Freight Payment</span>
                      <span className="__thirdSpan">{formatCurrency(summary.balance_freight)}</span>
                    </button>
                  </h2>
                  {balFreightList.length > 0 && (
                    <div className={`accordion-body ${activeAccordion.includes('collapseOne') ? 'show' : ''}`}>
                      {balFreightList.map((item, index) => (
                        <div key={index} className="__innerTb_xs">
                          <div className="__smAccr">
                            <h2>
                              Balance Freight Paid
                              {item.is_approval === 1 && (
                                <span className="__underAppro_tag">Under Approval</span>
                              )}
                            </h2>
                            <h2>{formatCurrency(item?.total_amount)}</h2>
                          </div>
                          <div className="__belowRtc">
                            <p>{formatDate(item?.date) || '-'} | {item?.voucher_no || '-'} | {getPaymentModeName(item) || '-'}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Advance Freight */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${activeAccordion.includes('collapseAdv') ? '' : 'collapsed'
                        } ${advFreightList.length === 0 ? 'no-arrow' : ''}`}
                      type="button"
                      onClick={() => advFreightList.length > 0 && toggleAccordion('collapseAdv')}
                    >
                      <span className="__firstSpan">Advance Freight</span>
                      <span className="__thirdSpan">{formatCurrency(summary.advance_freight)}</span>
                    </button>
                  </h2>
                  {advFreightList.length > 0 && (
                    <div className={`accordion-body ${activeAccordion.includes('collapseAdv') ? 'show' : ''}`}>
                      {advFreightList.map((item, index) => (
                        <div key={index} className="__innerTb_xs">
                          <div className="__smAccr">
                            <h2>
                              Advance Freight Paid
                              {item.is_approval === 1 && (
                                <span className="__underAppro_tag">Under Approval</span>
                              )}
                            </h2>
                            <h2>{formatCurrency(item?.total_amount)}</h2>
                          </div>
                          <div className="__belowRtc">
                            <p>{formatDate(item?.date) || '-'} | {item?.voucher_no || '-'} | {getPaymentModeName(item) || '-'}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Payable */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${activeAccordion.includes('collapsePayable') ? '' : 'collapsed'
                        } ${payableClaims.length === 0 ? 'no-arrow' : ''}`}
                      type="button"
                      onClick={() => payableClaims.length > 0 && toggleAccordion('collapsePayable')}
                    >
                      <span className="__firstSpan">Payable</span>
                      <span className="__thirdSpan">{formatCurrency(summary.payble || 0)}</span>
                    </button>
                  </h2>
                  {payableClaims.length > 0 && (
                    <div className={`accordion-body ${activeAccordion.includes('collapsePayable') ? 'show' : ''}`}>
                      {payableClaims.map((item, index) => (
                        <div key={index} className="__innerTb_xs">
                          <div className="__smAccr">
                            <h2>
                              {getCategoryName(item)}
                              {item.is_approval === 1 && (
                                <span className="__underAppro_tag">Under Approval</span>
                              )}
                            </h2>
                            <h2>{formatCurrency(item?.total_amount)}</h2>
                          </div>
                          <div className="__belowRtc">
                            <p>{formatDate(item?.date) || '-'} | {item?.voucher_no || '-'} | {getPaymentModeName(item) || '-'}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Deductions */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${activeAccordion.includes('collapseDeduction') ? '' : 'collapsed'
                        } ${deductionClaims.length === 0 ? 'no-arrow' : ''}`}
                      type="button"
                      onClick={() => deductionClaims.length > 0 && toggleAccordion('collapseDeduction')}
                    >
                      <span className="__firstSpan">Deductions</span>
                      <span className="__thirdSpan">{formatCurrency(summary.receivable || 0)}</span>
                    </button>
                  </h2>
                  {deductionClaims.length > 0 && (
                    <div className={`accordion-body ${activeAccordion.includes('collapseDeduction') ? 'show' : ''}`}>
                      {deductionClaims.map((item, index) => (
                        <div key={index} className="__innerTb_xs">
                          <div className="__smAccr">
                            <h2>
                              {getCategoryName(item)}
                              {item.is_approval === 1 && (
                                <span className="__underAppro_tag">Under Approval</span>
                              )}
                            </h2>
                            <h2>{formatCurrency(item?.total_amount)}</h2>
                          </div>
                          <div className="__belowRtc">
                            <p>{formatDate(item?.date) || '-'} | {item?.voucher_no || '-'} | {getPaymentModeName(item) || '-'}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="__footmob">
          <div className="__footFirst">
            <p>This is an automatically generated report. Powered by</p>
            <p><span><a href={redirect_url}>Transport360</a></span></p>
          </div>
          <div className="__footSecond">
            <p>Manage all your Trips & Accounting Easily</p>
            <div
              className={`__slideButton ${isDragging ? '__dragging' : ''} ${isCompleted ? '__completed' : ''}`}
              onMouseDown={handleStart}
              onMouseMove={handleMove}
              onMouseUp={handleEnd}
              onMouseLeave={handleEnd}
              onTouchStart={handleStart}
              onTouchMove={handleMove}
              onTouchEnd={handleEnd}
            >
              <div className="__slideTrack">
                <span className="__slideText">
                  {isCompleted ? 'Opening App Store...' : 'Slide to Download Transport360'}
                </span>
              </div>
              <div
                className="__slider"
                style={{ left: `${sliderPosition}px` }}
              >
                <i className={isCompleted ? "fa-solid fa-check" : "fa-solid fa-chevron-right"}></i>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TransportTripDetails;